$(document).ready(function () {
  $('#TryNowAddToCart').click(function (e) {
    e.preventDefault();
    var tryNowInput = $('#TryNowPropertyInput');
    var tryNowAddToCart = $('#TryNowAddToCart');

    tryNowInput.val(true);
    $('.add-to-cart')[0].click();
    tryNowAddToCart.prop('disabled', true).val('Limit 1 per customer');
  });
});

/* Try Now Modal */
var fade = function fade(modal, modalContent) {
  var opacity = 1;
  var timer = setInterval(function () {
    if (opacity <= 0.01) {
      clearInterval(timer);
    }

    opacity -= opacity * 0.05;
  }, 3);
  setTimeout(function () {
    modal.style.display = 'none';
  }, 300);
  modal.classList.add('TryNow__modal__hidden');
};

var unfade = function unfade(modal, modalContent) {
  modal.style.display = 'block';
  var opacity = 0.01;
  var timer = setInterval(function () {
    if (opacity >= 1) {
      clearInterval(timer);
    }

    opacity += opacity * 0.05;
  }, 1);
  modal.classList.remove('TryNow__modal__hidden');
};

var unfadeModal = function unfadeModal() {
  var modal = document.querySelector('.TryNow__modal');
  var modalContent = document.querySelector('.TryNow__modal__learn-more');
  unfade(modal, modalContent);
};

var fadeModal = function fadeModal() {
  var modal = document.querySelector('.TryNow__modal');
  var modalContent = document.querySelector('.TryNow__modal__learn-more');
  fade(modal, modalContent);
};

$(window).on('load', function() {
  // Get the modal
  var modal = $('#TryNowModal'); // Get the button that opens the modal
  var link = $('#TryNow__link'); // Get the <span> element that closes the modal
  var span = $('#TryNowHide');

  if (modal.length && link.length) {
    // When the user clicks the button, open the modal
    link.click(function() {
      unfadeModal();
    }); // When the user clicks on <span> (x), close the modal

    span.click(function() {
      fadeModal();
    }); // When the user clicks anywhere outside of the modal, close it

    $(window).click(function (event) {
      if (event.target == modal) {
        fadeModal();
      }
    });
  }
});